import VueRouter from 'vue-router'
import user from './user'
import account from './account'
import system from './system'
import algorithm from './algorithm'
import task from './task'
import chart from './chart'
import ad from "./ad";

const index = {
  path: '/',
  component: () => import('@/layouts/BaseLayout'),
  redirect: '/page/home',
  children: [
    {
      path: '/page/home',
      name: 'home',
      meta: { title: '首页' },
      component: () => import('@/views/home/Home.vue'),
    },
  ]
}

const notFound = {
  path: '*',
  name: 'notFound',
  meta: { title: '页面不存在' },
  component: () => import('@/views/NotFound/NotFound.vue')
}


const routes = [index, user, account, system, algorithm, task, chart, ad, notFound];

export default new VueRouter({ mode: 'history', routes })